import { FilterType } from '../enums/filter-type';

export declare class IRankingOrganisationSearchFilters {
	readonly [FilterType.BASE_RANKING_ID]: string;
	readonly [FilterType.YEAR]: string;
	readonly [FilterType.SHOW_UNRANKED]: string;
	readonly [FilterType.DISCIPLINE]: string | null;
	readonly [FilterType.COUNTRIES]: string | undefined;
	readonly [FilterType.REGIONS]: string | undefined;
	readonly [FilterType.AREAS]: string | undefined;
	readonly [FilterType.DELIVERY_METHODS]: string | undefined;
	readonly [FilterType.ORGANISATION]: string | undefined;
}
